import { useState } from "react";


//Cadastrar Equipamentos
import ChamadoAberto from './components/Grid-chamado-aberto.js';
import ChamadoAtendimento from './components/Grid-chamado-atendimento.js';
import ChamadoFinalizado from './components/Grid-chamado-finalizado.js';
import ChamadoCancelado from './components/Grid-chamado-cancelado.js';
import ChamadoTotal from './components/Grid-chamado-total.js';
import Botoes from './components/Grid-botoes.js';



import GlobalStyle from "../../../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";



const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;


const Div = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius:   15px ;

`;

const Container = styled.div`
  width: 90vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;


  div{
    width: 90vw;

  }
`;
const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;



function Usuarios({ setAtualizaFinalizados, atualizaFinalizados, intervalo, setIntervalo, lastUpdated, listaChamadoAberto, listaChamadoAtendimento, listaChamadoFinalizado, listaChamadoCancelado, listaChamadoTotal, quantidadeChamado, modalVerChamadoAberto, modalVerChamadoAtendimento, tipoAcessoModulo8, modalVerChamadoFinalizado, modalVerChamadoCancelado, setAnoSelecionado, anoSelecionado }) {

  // console.log(listaEquipamento)
  const [painelVisivel, setPainelVisivel] = useState('ABERTO');
  const [loading, setLoading] = useState(false);


  const trocarPainelComLoading = (novoPainel) => {
    setLoading(true);
    setTimeout(() => {
      setPainelVisivel(novoPainel);
      setLoading(false);
    }, 500); // 1 segundo
  };



  return (
    <>
      <Div>
        <Container>

          <label style={{
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}>
            Ano:
          </label>
          <select
            value={anoSelecionado}
            onChange={(e) => setAnoSelecionado(Number(e.target.value))}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              backgroundColor: 'white',
              fontSize: '0.95rem',
              minWidth: '110px',
            }}
          >
            <option value={2026}>2026</option>
            <option value={2025}>2025</option>
            <option value={2024}>2024</option>
          </select>

          {/* 
  
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexWrap: 'wrap',

            }}>


              <div style={{
                display: 'flex',
                gap: '20px',
                marginLeft: '100px',
              }}>
                <label style={{
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                }}>
                  Atualizar a cada:
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="intervalo"
                    value={60000}
                    checked={intervalo === 60000}
                    onChange={(e) => setIntervalo(Number(e.target.value))}
                  />
                  1 min
                </label>

                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="intervalo"
                    value={300000}
                    checked={intervalo === 300000}
                    onChange={(e) => setIntervalo(Number(e.target.value))}
                  />
                  5 min
                </label>

                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="intervalo"
                    value={600000}
                    checked={intervalo === 600000}
                    onChange={(e) => setIntervalo(Number(e.target.value))}
                  />
                  10 min
                </label>
              </div>
            </div>


          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // evita que fique muito apertado
          }}>
            {lastUpdated && (
              <div style={{
                flexShrink: 0,
                whiteSpace: 'nowrap',
              }}>
                <p style={{
                  margin: 0,
                  fontSize: '0.875rem',
                  color: '#6b7280',
                  fontStyle: 'italic',
                }}>
                  Última atualização: {lastUpdated.toLocaleString('pt-BR', {
                    dateStyle: 'short',
                    timeStyle: 'short'
                  })}
                </p>
              </div>
            )}
          </div> */}



          <Botoes
            onAberto={() => trocarPainelComLoading('ABERTO')}
            onAtendimento={() => trocarPainelComLoading('ATENDIMENTO')}
            onFinalizado={() => trocarPainelComLoading('FINALIZADO')}
            onCancelado={() => trocarPainelComLoading('CANCELADO')}
            onTotal={() => trocarPainelComLoading('TOTAL')}
            painelVisivel={painelVisivel}
            quantidadeChamado={quantidadeChamado}
            tipoAcessoModulo8={tipoAcessoModulo8}
          />



          {loading ? (
            <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
          ) : (
            <>
              {painelVisivel === 'ABERTO' && (
                <ChamadoAberto
                  listaChamadoAberto={listaChamadoAberto}
                  modalVerChamadoAberto={modalVerChamadoAberto}
                />
              )}

              {painelVisivel === 'ATENDIMENTO' && (
                <ChamadoAtendimento
                  listaChamadoAtendimento={listaChamadoAtendimento}
                  modalVerChamadoAtendimento={modalVerChamadoAtendimento}
                />
              )}

              {painelVisivel === 'FINALIZADO' && (
                <ChamadoFinalizado listaChamadoFinalizado={listaChamadoFinalizado}
                  modalVerChamadoFinalizado={modalVerChamadoFinalizado} setAtualizaFinalizados={setAtualizaFinalizados} atualizaFinalizados={atualizaFinalizados} />
              )}

              {painelVisivel === 'CANCELADO' && (
                <ChamadoCancelado listaChamadoCancelado={listaChamadoCancelado}
                  modalVerChamadoCancelado={modalVerChamadoCancelado} setAtualizaFinalizados={setAtualizaFinalizados} atualizaFinalizados={atualizaFinalizados} />

              )}

              {painelVisivel === 'TOTAL' && (
                <ChamadoTotal listaChamadoTotal={listaChamadoTotal}
                  modalVerChamadoFinalizado={modalVerChamadoFinalizado} setAtualizaFinalizados={setAtualizaFinalizados} atualizaFinalizados={atualizaFinalizados} />

              )}
            </>
          )}



        </Container>

        <div>
          <ToastContainer
            autoClose={2500}
            position={toast.POSITION.BOTTOM_LEFT}
            style={{ width: '400px', fontSize: '22px' }}
          />

        </div>
      </Div>

      <GlobalStyle />
    </>
  );
}

export default Usuarios;
